/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { useCalendar } from "./useCalendar";
import { useCalendarItems } from "./useCalendarItems";
import { getDisplayValue } from "../utils/getDisplayValue";
import { useCalendarValue } from "./useCalendarValue";

export function useCalendarDisplayValue(): string | string[] {
  const context = useCalendar();
  const [items] = useCalendarItems();
  const [value] = useCalendarValue();
  const displayValue = useMemo(() => getDisplayValue(value, items, context.multiple), [value, items]);
  return displayValue;
}
